export const withPreviousResult = (func, defaultValue) => {
  let previousResult = defaultValue;

  return (result, ...args) => {
    previousResult = func(previousResult, ...args);

    return previousResult;
  };
};
